import React from "react";
import { tagPurchase } from "../../../../utils/sendTag";
import useBotControlStore from "../../../../storeModules/useBotControlStore";
import findStep from "../findStep";
import useConsorcioStore from "../../../../storeModules/useConsorcioStore";
import useInitialConfigStore from "../../../../storeModules/useInitialConfigStore";
import useUserStore from "../../../../storeModules/useUserStore";
import getFinalPaymentValue from "../../../../utils/getFinalPaymentValue";
import { metodosPagamentoNames } from "../../../../utils/constants";
import { acionarEspecialistaTag } from "../../../../utils/sendTag/index";
import { CARD_PAYMENT_REFUSED_GIF_URL } from "../../../../utils/paymentImageUrls";
import { sanitizeUrl } from "../../../../utils/sanitize";

const pagamentoCartaoSteps = [
  {
    name: "mensagem_seguranca_cartao",
    sender: "bot",
    text: "Pagar no cartão é rápido e <b>100% seguro.</b>",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("escolha_parcelas_cartao").index,
      });
    },
  },
  {
    name: "escolha_parcelas_cartao",
    sender: "bot",
    text: "Você pode pagar em <b>até 3x sem juros :)</b>",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("valor_parcelas_cartao").index,
      });
    },
  },
  {
    name: "valor_parcelas_cartao",
    sender: "bot",
    text: () => {
      return `O pagamento será realizado no valor de <b>${getFinalPaymentValue()}</b>.`;
    },
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("formulario_cartao").index,
      });
    },
  },
  {
    name: "formulario_cartao",
    sender: "bot",
    text: "Escolha uma das opções",
    options: [
      {
        text: "PAGAR NO CARTÃO",
        action: () => {
          useBotControlStore.setState({
            showPaymentModal: true,
          });
        },
      },
      {
        text: "ALTERAR FORMA DE PAGAMENTO",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("alterar_forma_pagamento").index,
          });
        },
      },
    ],
  },
  {
    name: "processando_cartao",
    sender: "bot",
    text: "Aguarde um momento enquanto processamos o seu pagamento.",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("sucesso_cartao").index,
      });
    },
  },
  {
    name: "sucesso_cartao",
    sender: "bot",
    text: "Prontinho! Estamos felizes em fazer parte do seu sonho.",
  },
  {
    name: "cartao_pendente",
    sender: "bot",
    text: "<b>Seu pagamento cartão está em processamento.</b> Por favor, aguarde a confirmação que será enviada para o seu e-mail.",
    action: async () => {
      tagPurchase(metodosPagamentoNames["CARTÃO"]);
      useBotControlStore.setState({
        currentStep: findStep("compra_finalizada").index,
      });
    },
  },

  {
    name: "cartao_recusado",
    sender: "bot",
    text: "<b>Pagamento recusado :(</b> <br/><br/> O quê você deseja fazer?",
    options: () => {
      return useConsorcioStore
        .getState()
        .fetchedProposta.formasPagamentoDisponiveis.filter((code) =>
          [5, 0, 1].includes(code),
        )
        .map((code) => {
          const options = {
            5: {
              text: "PAGAR COM PIX",
              action: () => {
                useBotControlStore.setState({
                  currentStep: findStep("registro_pix").index,
                });
              },
            },
            0: {
              text: "TENTAR NOVAMENTE",
              action: () => {
                useBotControlStore.setState({
                  currentStep: findStep("mensagem_seguranca_cartao")
                    .index,
                });
              },
            },
            1: {
              text: "PAGAR COM BOLETO",
              action: () => {
                useBotControlStore.setState({
                  currentStep: findStep("gerando_boleto").index,
                });
              },
            },
          };
          return options[code];
        })
        .concat([
          {
            text: "FALAR COM NOSSOS ESPECIALISTAS",
            action: () => {
              const linkWhatsApp =
                useInitialConfigStore.getState().linkWhatsApp;
              window.open(sanitizeUrl(linkWhatsApp), "_blank");
              acionarEspecialistaTag("pagamento_cartao_recusado");
            },
          },
        ]);
    },
    component: (
      <img
        className="card-payment"
        src={CARD_PAYMENT_REFUSED_GIF_URL}
        alt="Cartão recusado"
      />
    ),
  },
  {
    name: "pagamento_pendente",
    sender: "bot",
    text: "<b>Seu pagamento está sendo validado :)</b> <br><br> Aguarde a confirmação que será enviada para o seu e-mail. Qualquer dúvida, entre em contato com nosso time de especialistas.",
    options: [
      {
        text: "FALAR COM NOSSOS ESPECIALISTAS",
        action: () => {
          const linkWhatsApp = useInitialConfigStore.getState().linkWhatsApp;
          window.open(sanitizeUrl(linkWhatsApp), "_blank");
          acionarEspecialistaTag("pagamento_cartao_pendente");
        },
      },
    ],
  },
  {
    name: "pagamento_aprovado",
    sender: "bot",
    text: () => {
      const { cartaoAutorizacao } = useUserStore.getState().payment;
      return `<b>Seu pagamento foi realizado com sucesso!</b> <br><br> nº ${cartaoAutorizacao}`;
    },
    action: async () => {
      tagPurchase(metodosPagamentoNames["CARTÃO"]);
      useBotControlStore.setState({
        currentStep: findStep("compra_finalizada").index,
      });
    },
  },
];

export default pagamentoCartaoSteps;
